import { DashboardFeatureId } from '../../../../../AdviserArea/AdviserArea.types';
import { BehavioralFinanceTools } from '../../../../ClientAccess.types';
import { beFiPlanSubFeatures } from '../Dashboard/Dashboard.meta';

interface useBeFiProps {
  accessSet: DashboardFeatureId[];
  dashboardAccessOptions: { label: string; value: number }[];
  hiddenBeFiTools?: BehavioralFinanceTools[];
}

export const useBeFi = ({ accessSet, dashboardAccessOptions, hiddenBeFiTools }: useBeFiProps) => {
  const hasFinancialPlanEnabled = accessSet.includes(DashboardFeatureId.FinancialPlan);

  const allowedBeFiTools = dashboardAccessOptions.filter(
    item => beFiPlanSubFeatures.includes(item.value) && !hiddenBeFiTools?.includes(item.value),
  );

  const allowedBeFiIds = allowedBeFiTools.map(item => item?.value);

  return { hasFinancialPlanEnabled, allowedBeFiTools, allowedBeFiIds };
};
